import { defineComponent } from 'vue'
import { ReloadOutlined } from '@ant-design/icons-vue'
import { Tooltip } from 'ant-design-vue'
import styles from './headerBtn.module.less'
export default defineComponent({
  name: 'TableRefresh',
  components: { Tooltip, ReloadOutlined },
  emits: ['reload'],
  setup(_, { emit }) {
    return () => (
      <Tooltip title='刷新' placement='top'>
        <div class={styles.btn} onClick={() => emit('reload')}>
          <ReloadOutlined />
        </div>
      </Tooltip>
    )
  }
})
